export const SORT_DIRECTIONS = {
    ASC: "ascending",
    DESC: "descending",
    NONE: "none"
};
